import React, { useEffect, useState } from "react";
import { collection, query, where, orderBy, onSnapshot, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";
import { useSession } from "../auth.jsx";
import { Eyebrow } from "../components/Bits.jsx";

export default function Journal() {
  const s = useSession();
  const [entries, setEntries] = useState([]);
  const [text, setText] = useState("");
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    if (!s.user) return;
    const q = query(collection(db, "journal"), where("residentUid", "==", s.user.uid), orderBy("createdAt", "desc"));
    return onSnapshot(q, (snap) => setEntries(snap.docs.map((d) => ({ id: d.id, ...d.data() }))));
  }, [s.user]);

  const file = async () => {
    if (text.trim().length < 41) return setMsg("An entry needs more than a line. Say what you decided and what would reverse it.");
    try {
      await addDoc(collection(db, "journal"), {
        residentUid: s.user.uid,
        cohortId: s.profile?.cohortId ?? null,
        text: text.trim(),
        createdAt: serverTimestamp(),
      });
      setText(""); setMsg(null);
    } catch (e) { setMsg(e.message); }
  };

  const words = text.trim() ? text.trim().split(/\s+/).length : 0;

  return (
    <div style={{ maxWidth: 760 }}>
      <Eyebrow style={{ color: "var(--madder)" }}>Decision journal · Tier 0 · no AI</Eyebrow>
      <h1 style={{ fontSize: 24, marginTop: 4 }}>One decision. Why. What would reverse it.</h1>
      <p style={{ color: "var(--graphite)" }}>
        Entries are permanent once filed — they cannot be edited or deleted, which is what makes them
        evidence of what you thought at the time. Examiners draw three of these at your defence.
      </p>

      <textarea rows={6} value={text} onChange={(e) => setText(e.target.value)} style={{ marginTop: 12 }}
        placeholder="This week I decided…  I decided it because…  I would reverse it if…" />
      <div className="row between" style={{ marginTop: 8 }}>
        <span className="mono" style={{ fontSize: 12, color: "var(--graphite)" }}>{words} words</span>
        <button className="btn" onClick={file}>File entry</button>
      </div>
      {msg && <div className="warn" style={{ marginTop: 10 }}>{msg}</div>}

      <div style={{ marginTop: 24 }}>
        {entries.map((e) => (
          <div key={e.id} className="card" style={{ marginBottom: 12, borderLeft: "3px solid var(--indigo)" }}>
            <div className="mono" style={{ fontSize: 11, color: "var(--graphite)" }}>
              {e.createdAt?.toDate?.().toLocaleDateString?.() ?? "just now"}
            </div>
            <p style={{ marginTop: 6, whiteSpace: "pre-wrap" }}>{e.text}</p>
          </div>
        ))}
        {!entries.length && <p style={{ color: "var(--graphite)", fontStyle: "italic" }}>Nothing filed yet. The first entry is the hardest.</p>}
      </div>
    </div>
  );
}
